const changeSettings = {
	init: function () {
		// Email change handler
		document.getElementById('email').addEventListener('change', function () {
			const email = this;
			const oldEmail = email.getAttribute('data-original');
			const newEmail = email.value;
			const form = email.closest('form');
			const submitButton = form.querySelector('button[type="submit"]');
			const changeEmail = form.querySelector('#confirmEmailChange');

			if (newEmail === oldEmail) {
				if (submitButton.disabled) {
					submitButton.disabled = false;
					changeEmail.classList.add('d-none');
				}
			} else {
				submitButton.disabled = true;
				changeEmail.classList.remove('d-none');
			}
		});

		// Confirm email change handler
		document.getElementById('confirmChangeEmail').addEventListener('change', function () {
			const confirm = this;
			const value = confirm.value;
			const form = confirm.closest('form');
			const submitButton = form.querySelector('button[type="submit"]');

			if (value !== 'Y') {
				submitButton.setAttribute('disabled', 'disabled');
			} else {
				submitButton.removeAttribute('disabled');
			}
		});
	},
};

export default changeSettings;
